module.exports = __webpack_public_path__ + "static/media/heart.e87899ae.svg";